import draftMode from './draftMode.cjs';

export const {
  DRAFT_MODE_STORAGE_KEY,
  RECKON_DOMAIN,
  canViewContent,
  canLinkToContent,
  isAuthorizedReckonUser,
  isPublished,
  normalizeEmail,
  readDraftModePreference,
  publicDiscoveryContent,
  visibleContent,
  writeDraftModePreference,
} = draftMode;

export default draftMode;
